// VITE_APP_ENV values in use today: local, dev, staging, uat, training — production has no
// value here (see NavMenu's EnvBadge), so anything unmapped is treated as prod.
const CURRENT_ENV = import.meta.env.VITE_APP_ENV ?? '';

// The Tickets module is enabled only in dev and staging.
export function isTicketsAllowedEnvironment(): boolean {
  return ['dev', 'staging'].includes(CURRENT_ENV);
}
